import React, { ReactElement } from "react";
import Layout from "../../components/layout";
import ShopsList from "../../components/Shops";

const ShopsListPage = (): ReactElement => {
  return (
    <Layout>
      <ShopsList />
    </Layout>
  );
};

export default ShopsListPage;
